import './config/constants';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import App from './components/App';
import LoginStore from './store/LoginStore';
import './styles/main.css';

const Root = (
  <Provider LoginStore={LoginStore}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

const start = async () => {
  // LoginStore is cleared on page refresh
  // Here we hydrate some of the store properties before the components re-mount
  await LoginStore.hydrate();
  const element = document.getElementById('root');
  if (!element) return;

  const root = ReactDOM.createRoot(element);
  root.render(Root);
};

start();
